module.exports = __webpack_public_path__ + "media/on-location.97ff9c9c.mp4";